import { FC, PropsWithChildren, useCallback, useMemo } from 'react';
import { createStore } from './Store';

export const createBlockerStore = () => {
  const store = createStore<{ subscribers: Set<string> }>();

  const Provider: FC<PropsWithChildren> = ({ children }) => {
    return (
      <store.Provider initialData={{ subscribers: new Set() }}>
        {children}
      </store.Provider>
    );
  };

  const useStore = () => {
    const [blockers, , setBlockers] = store.useValue('subscribers');
    const getBlockers = store.useGetValue('subscribers');

    const methods = useMemo(
      () => ({
        add: () => {
          const blockerId = window.crypto.randomUUID();
          setBlockers((prev) => new Set(prev).add(blockerId));

          const remove = () => {
            setBlockers((prev) => {
              const newBlockers = new Set(prev);
              newBlockers.delete(blockerId);
              return newBlockers;
            });
          };

          return remove;
        },
        clear: () => setBlockers(() => new Set()),
      }),
      [setBlockers],
    );

    // Prevents stale references to old hasBlocker values
    // that cause duplicate navigation prompts
    const getHasBlockers = useCallback(
      () => getBlockers().size > 0,
      [getBlockers],
    );

    return {
      has: blockers.size > 0,
      getHasBlockers,
      ...methods,
    };
  };

  return { Provider, useStore };
};
